export const beigeTheme = {
  // Background colors
  primaryBg: 'linear-gradient(135deg, #f5f5dc 0%, #faf0e6 50%, #f5f5dc 100%)',
  secondaryBg: 'rgba(245, 245, 220, 0.95)',
  tertiaryBg: 'rgba(250, 240, 230, 0.9)',
  modalBg: 'rgba(245, 245, 220, 0.98)',
  
  // Text colors
  primaryText: '#2d3748',
  secondaryText: '#4a5568',
  tertiaryText: '#718096',
  mutedText: '#a0aec0',
  
  // Border colors
  primaryBorder: 'rgba(45, 55, 72, 0.2)',
  secondaryBorder: '#d69e2e',
  accentBorder: 'rgba(214, 158, 46, 0.4)',
  border: 'rgba(45, 55, 72, 0.2)', // Alias for primaryBorder
  
  // Button colors
  primaryButton: 'linear-gradient(135deg, #d69e2e 0%, #b7791f 100%)',
  secondaryButton: 'linear-gradient(135deg, #38a169 0%, #2f855a 100%)',
  accentButton: 'linear-gradient(135deg, #9f7aea 0%, #805ad5 100%)',
  dangerButton: 'linear-gradient(135deg, #e53e3e 0%, #c53030 100%)',
  
  // Input colors
  inputBg: 'rgba(255, 255, 255, 0.8)',
  inputBorder: 'rgba(45, 55, 72, 0.2)',
  inputFocusBorder: '#d69e2e',
  
  // Card colors
  cardBg: 'rgba(255, 255, 255, 0.9)',
  cardHoverBg: 'rgba(250, 240, 230, 0.95)',
  
  // Shadow colors
  primaryShadow: 'rgba(45, 55, 72, 0.15)',
  accentShadow: 'rgba(214, 158, 46, 0.25)',
  
  // Logo gradient
  logoGradient: 'linear-gradient(135deg, #d69e2e 0%, #38a169 100%)',
  
  // Voice button colors
  voiceButtonIdle: 'linear-gradient(135deg, #d69e2e 0%, #b7791f 100%)',
  voiceButtonRecording: 'linear-gradient(135deg, #e53e3e 0%, #c53030 100%)',
  
  // Quick options colors
  quickOptionBg: 'rgba(255, 255, 255, 0.8)',
  quickOptionHover: 'rgba(250, 240, 230, 0.9)',
  quickOptionBorder: '#d69e2e',
  quickOptionText: '#4a5568',
  
  // Business type colors
  businessTypeBg: 'rgba(255, 255, 255, 0.9)',
  businessTypeHover: 'rgba(250, 240, 230, 0.95)',
  businessTypeText: '#4a5568',
  
  // Modal colors
  modalOverlay: 'rgba(45, 55, 72, 0.6)',
  modalBorder: 'rgba(214, 158, 46, 0.4)',
  
  // Close button colors
  closeButtonBg: 'rgba(229, 62, 62, 0.15)',
  closeButtonBorder: 'rgba(229, 62, 62, 0.3)',
  closeButtonText: '#e53e3e',
  closeButtonHover: 'rgba(229, 62, 62, 0.25)',
  
  // Thinking animation colors
  thinkingBg: 'rgba(255, 255, 255, 0.9)',
  thinkingBorder: 'rgba(214, 158, 46, 0.3)',
  nucleusGradient: 'radial-gradient(circle, #d69e2e, #b7791f)',
  electronColor: '#f6ad55',
  
  // Message colors
  userMessageBg: 'linear-gradient(135deg, #d69e2e 0%, #b7791f 100%)',
  botMessageBg: 'rgba(255, 255, 255, 0.8)',
  messageText: '#2d3748',
  
  // Welcome message colors
  welcomeText: '#4a5568',
  welcomeSubtext: '#718096',
  
  // Additional properties needed by ChatHistory component
  primary: '#d69e2e',
  primaryHover: '#b7791f',
  warningBg: 'rgba(245, 158, 11, 0.15)',
  warningBorder: 'rgba(245, 158, 11, 0.3)',
  warningText: '#d97706',
  error: '#e53e3e',
  errorBg: 'rgba(229, 62, 62, 0.15)',
  
  // ChatHistory specific properties
  primaryBgHover: 'rgba(250, 240, 230, 0.95)',
  
  // Additional properties used by FullChatPage
  bg: 'linear-gradient(135deg, #f5f5dc 0%, #faf0e6 50%, #f5f5dc 100%)', // Alias for primaryBg
  text: '#2d3748' // Alias for primaryText
}; 